import { useEffect } from "react";
import { useDispatch } from "react-redux";
import FullscreenDialog from "../../../../components/listing/FullscreenDialog";
import { clearRepairOrderRagDetail } from "../../../../redux/features/inventories/inventoriesSlice";
import RoDetail from "../screens/RoDetail";

const RoDetailFullscreenDialog = ({
  open,
  onClose,
  isClosePending = false,
}) => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (!open) {
      dispatch(clearRepairOrderRagDetail());
    }
  }, [dispatch, open]);

  return (
    <FullscreenDialog open={open} onClose={onClose}>
      {open ? (
        <RoDetail onBack={onClose} isClosePending={isClosePending} />
      ) : null}
    </FullscreenDialog>
  );
};

export default RoDetailFullscreenDialog;
